/**************************************************
 * Nombre:       Home_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Parallax} from 'react-parallax';
import fondo from '../../../Recursos/fondo_servicios.png'
import {ArrowForward, Flatware, Spa, Water} from '@mui/icons-material'
import Tarjeta_Servicios from "../../Tarjetas/Tarjeta_Servicios";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Servicios = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Parallax
                    // blur={{min: -15, max: 15}}
                    bgImage={fondo}
                    bgImageAlt="the dog"
                    strength={-200}
                    style={{width: '100%'}}
                >


                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 20, pb: 10}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={4}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{
                                                fontSize: sCell ? 32 : 48,
                                                fontWeight: 800,
                                                fontFamily: 'Raleway',
                                                lineHeight: 1.2,
                                                textAlign: sCell ? 'center' : 'left',
                                            }}>

                                                Cada Detalle Pensado Para Ti
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography sx={{
                                                fontSize: 16,
                                                fontWeight: 400,
                                                fontFamily: 'Roboto',
                                                color: '#C4C4C4',
                                                textAlign: sCell ? 'center' : 'left',
                                            }}>
                                                Cada detalle está diseñado para que disfrutes y te sientas en armonía
                                                con la naturaleza.
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: sCell ?'center' : 'flex-start', mt: 2}}>
                                            <Button
                                                onClick={() => iniciarChatWass({mensaje: 'Hola, quiero saber mas de los servicios de Magaza Lodge'})}
                                                endIcon={<ArrowForward/>}>Saber Mas</Button>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'center'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={sCell ? 2 : 4}
                                    >

                                        {servicio.map((it, index) => {
                                            return (
                                                <Grid container size={{xs: 6, sm: 4, md: 4}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Tarjeta_Servicios item={it}/>
                                                </Grid>
                                            )

                                        })}


                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

                </Parallax>
            </Grid>


        </Grid>
    )

}
export default Home_Servicios

const servicio = [
    {
        icono: Flatware,
        nombre: 'Restaurante',
        descripcion: "sabores locales y frescos"
    },
    {
        icono: Spa,
        nombre: 'Spa',
        descripcion: "tranquilidad en todo momento"
    },
    {
        icono: Water,
        nombre: 'Jacuzzi',
        descripcion: "relajarte en plena naturaleza."
    },
]